export default __webpack_public_path__ + "static/media/home_img-bottom.a678d0c4-2.9adadf3e.png";